// extracted by mini-css-extract-plugin
export default {"birthday-container__profile":"Profile_birthday-container__profile__vj5UY","image":"Profile_image__xnx-C","details":"Profile_details__+3Bfd"};